export default __webpack_public_path__ + "static/media/file Icon.48e22ddc.svg";